import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import OrderPage from './pages/OrderPage';
import OrderTokenPage from './pages/OrderTokenPage';
import './App.css';

function RedirectToWebsite() {
  useEffect(() => {
    window.location.href = 'https://vitalinsights.in/';
  }, []);
  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/order/:token" element={<OrderTokenPage />} />
        <Route path="/:token" element={<OrderPage />} />
        <Route path="*" element={<RedirectToWebsite />} />
      </Routes>
    </Router>
  );
}

export default App;
